import Phaser from 'phaser';
import { GAME_WIDTH } from '../config';
import { AudioManager } from '../systems/AudioManager';

export type ToastKind = 'default' | 'gold' | 'error';

export class ToastManager {
  private scene: Phaser.Scene;
  private container: Phaser.GameObjects.Container | null = null;
  private hideTimer: Phaser.Time.TimerEvent | null = null;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  show(message: string, kind: ToastKind = 'default'): void {
    AudioManager.playSfx('toast');
    this.hide();

    const bg = kind === 'gold' ? 0xf0a020 : kind === 'error' ? 0xe54e87 : 0x3a2540;
    const text = this.scene.add.text(0, 0, message, {
      fontFamily: 'Pretendard Variable, Pretendard, sans-serif',
      fontSize: '20px',
      fontStyle: '700',
      color: '#ffffff',
      padding: { x: 24, y: 14 },
    }).setOrigin(0.5);

    const w = text.width;
    const h = text.height;
    const rect = this.scene.add.rectangle(0, 0, w, h, bg, 0.95);
    rect.setStrokeStyle(0);

    const c = this.scene.add.container(GAME_WIDTH / 2, 100, [rect, text]);
    c.setDepth(10000);
    c.setAlpha(0);
    this.scene.tweens.add({ targets: c, alpha: 1, y: 88, duration: 200, ease: 'Cubic.Out' });

    this.container = c;
    this.hideTimer = this.scene.time.delayedCall(2000, () => this._fadeOut());
  }

  private _fadeOut(): void {
    if (!this.container) return;
    const c = this.container;
    this.scene.tweens.add({
      targets: c,
      alpha: 0,
      y: (c.y as number) - 12,
      duration: 250,
      ease: 'Cubic.In',
      onComplete: () => { c.destroy(); },
    });
    this.container = null;
    this.hideTimer?.remove();
    this.hideTimer = null;
  }

  hide(): void {
    if (this.container) {
      this.container.destroy();
      this.container = null;
    }
    this.hideTimer?.remove();
    this.hideTimer = null;
  }
}
